import * as api from '../../api/otp';
import * as mutationTypes from './mutationTypes'
import { getErrorMessage } from "@/helpers/functions";

function timeDeltaFromDateTime(dateTime) {
  const dateDiff = Date.now() - Date.parse(dateTime);
  const minutes = Math.floor(dateDiff / (1000 * 60));
  const hours = Math.floor(minutes / 60);

  return { hours: hours, minutes: minutes % 60 };
}

function calculateRemainingTime(deltaHours, deltaMinutes) {
  const hoursLeft = deltaMinutes > 0 ? 23 - deltaHours : 24 - deltaHours;
  const minutesLeft = deltaMinutes === 0 ? 0 : 60 - deltaMinutes;
  return { hoursLeft, minutesLeft };
}

function processOtpResponse(otpResponse) {
  if (!otpResponse?.delivery_status) {
    return { otpStatus: 'NOT_STARTED', hours: 0, minutes: 0 };
  }

  if (otpResponse.delivery_status === 'NOT_STARTED') {
    return { otpStatus: 'NOT_STARTED', hours: 0, minutes: 0 };
  }

  if (otpResponse.delivery_status === 'FINISHED') {
    return { otpStatus: 'FINISHED', hours: 0, minutes: 0 };
  }

  if (!otpResponse.delivery_status_date) {
    return { otpStatus: otpResponse.delivery_status, hours: 0, minutes: 0 };
  }

  const { hours: deltaHours, minutes: deltaMinutes } = timeDeltaFromDateTime(otpResponse.delivery_status_date);

  if (deltaHours >= 24) {
    return { otpStatus: 'REQUIRE_RESEND', hours: 0, minutes: 0 };
  }

  const { hoursLeft, minutesLeft } = calculateRemainingTime(deltaHours, deltaMinutes);

  return {
    otpStatus: otpResponse.delivery_status,
    hours: hoursLeft,
    minutes: minutesLeft,
  };
}

function codeAndMsgFromError(error) {
  let errorMsg = getErrorMessage(error);
  let errorCode = error.toString().match('\\d{3}')[0];

  return { errorCode, errorMsg }
}

const actions = {
  async fetchOtpState({ commit, rootState }, { brandId }) {
    commit(mutationTypes.FETCH_OTP_STATE);
    const credentials = rootState.credentials;

    try {
      const { data: otpResponse } = await api.getOtpState(brandId, credentials);
      const stateUpdate = processOtpResponse(otpResponse);
      commit(mutationTypes.FETCH_STATE_SUCCESS, stateUpdate);
    } catch (e) {
      commit(mutationTypes.FETCH_STATE_ERROR, { otpError: getErrorMessage(e) });
    }
  },

  async requestOtp({ commit, rootState }, { brandId }) {
    commit(mutationTypes.REQUEST_OTP);
    const credentials = rootState.credentials;

    try {
      const { data: otpResponse } = await api.requestOtp(brandId, credentials);
      const stateUpdate = processOtpResponse(otpResponse);
      commit(mutationTypes.FETCH_STATE_SUCCESS, stateUpdate);
    } catch (e) {
      commit(mutationTypes.REQUEST_OTP_ERROR, { otpError: getErrorMessage(e) });
    }
  },

  async sendOtp({ commit, rootState }, { brandId, code }) {
    commit(mutationTypes.SEND_OTP);
    const credentials = rootState.credentials;

    try {
      await api.sendOtp(brandId, credentials, code);
      commit(mutationTypes.SEND_OTP_SUCCESS);
    } catch (e) {
      let { errorCode, errorMsg } = codeAndMsgFromError(e);

      commit(mutationTypes.SEND_OTP_ERROR, { otpError: errorCode === '401' ? 'INVALID_CODE' : errorMsg });
    }
  },

  requireResend({ commit }) {
    commit(mutationTypes.REQUIRE_RESEND);
  },

  clearError({ commit }) {
    commit(mutationTypes.CLEAR_ERROR);
  },
};

export default actions;
